<template>
  <section
    :class="[
      'px-5 md:p-12.5 lg:p-25 transition-[padding_gap]',
      { 'grid gap-8 lg:gap-15 lg:grid-cols-2': content.image },
    ]"
  >
    <ResponsiveImage
      :media="content.image"
      :class="['aspect-4/3 object-cover max-h-96 lg:max-h-none mx-auto']"
    />
    <TitleBlock
      :subtitle="content.subtitle"
      :title="content.title"
      :description="content.description"
      :buttons="content.buttons"
      :center="!content.image"
      :section_bg="content.background"
      :class="{ 'px-5 ml-0 lg:-order-1': content.reverse }"
    />
  </section>
</template>

<script lang="ts">
import { TitleBlock } from "@/components/blocks";
import { ResponsiveImage } from "@/components/helpers";

export default {
  name: "TextImageSection",
  components: { TitleBlock, ResponsiveImage },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>
